import React, { useEffect } from 'react'

const Toast = ({message, onClose, duration = 4000, type = 'success'}) => {
    useEffect(()=>{
        const timmer = setTimeout(onClose,duration);
        return()=>clearTimeout(timmer);
    },[onClose, duration])


const backgroundColor = type === 'error' ? "#e63946" : "#0dbf22";
const textColor = "White"

    

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        backgroundColor: backgroundColor,
        color: textColor,
        padding: "10px 16px",
        borderRadius: "6px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        zIndex: 9999,
      }}
    className='animate-slideInFromRight'>
      {message}
    </div>

  )
}

export default Toast